import iconMenu from '@/assets/img/menu/home.png';
import iconSwitchFournisseur from '@/assets/img/menu/menu.png';
import iconIntervention from '@/assets/img/menu/outils.png';
import iconDevis from '@/assets/img/menu/calculate.png';
import iconDocuments from '@/assets/img/menu/docs.png';
import iconFacturation from '@/assets/img/menu/receipt_long.png';
import iconAdministratif from '@/assets/img/menu/bag.png';
import iconEnergie from '@/assets/img/menu/show_chart.png';
import iconNew from '@/assets/img/menu/icons8-nouveau-100.png';
import iconReclamation from '@/assets/img/menu/error.png';
import iconContact from '@/assets/img/menu/mail.png';
import iconSatisfaction from '@/assets/img/menu/sentiment_satisfied.png';
import { Site } from '@/models/Site';
import { store } from '@/plugins/store';
import i18n from '@/plugins/i18n';
import { StatutBim } from '@/models/StatutBim';

export const MENU_CLIENT = [
    {
        href: '/dashboard',
        title: 'Dashboard',
        icon: {
            element: 'img',
            attributes: { src: iconMenu}
        }
    },
    {
        title: 'Interventions',
        icon: {
            element: 'img',
            attributes: { src: iconIntervention}
        },
        child: [
            {
                href: '/intervention',
                title: 'Faire une demande',
                icon: 'none'
            },
            {
                href: '/suivi-demande-intervention',
                title: 'Voir toutes les demandes',
                icon: 'none'
            },
            {
                href: '/suivi-preventif',
                title: 'Planning préventif',
                icon: 'none'
            },
            {
                href: '/suivi-interventions-preventives',
                title: 'Voir toutes les interventions préventives',
                icon: 'none'
            },
            {
                href: '/suivi-travaux',
                title: 'Voir toutes les interventions non préventives',
                icon: 'none'
            },
            {
                title: 'Rapports à signer',
                href: '/rapports-a-signer',
                icon: 'none'
            },
        ]
    },
    {
        title: 'Devis',
        icon: {
            element: 'img',
            attributes: { src: iconDevis}
        },
        child: [
            {
                href: '/devis',
                title: 'Faire une demande de devis',
                icon: 'none'
            },
            {
                title: 'Suivi des demandes de devis',
                href: '/suivi-demandes-devis',
                icon: 'none'
            },
            {
                href: '/suivi-devis',
                title: 'Voir tous les devis',
                icon: 'none'
            },
        ],
    },
    {
        title: 'Documents',
        icon: {
            element: 'img',
            attributes: { src: iconDocuments }
        },
        child: [
            {
                title: 'DOE',
                href: '/doe',
                icon: 'none'
            },
            {
                title: 'Rapports d\'intervention',
                href: '/rapports',
                icon: 'none'
            },
            {
                title: 'Réglementaires',
                href: '/documents',
                icon: 'none'
            },
        ]
    },
    {
        title: 'Administratif',
        icon: {
            element: 'img',
            attributes: { src: iconAdministratif }
        },
        child: [
            {
                title: 'Equipements',
                href: '/equipements',
                icon: 'none'
            },
            {
                title: 'Tags NFC',
                href: '/tag-nfc',
                icon: 'none'
            },
        ]
    },
    {
        title: 'Facturation',
        icon: {
            element: 'img',
            attributes: { src: iconFacturation }
        },
        href: '/facturation'
    },
    {
        title: 'Votre suivi énergétique',
        icon: {
            element: 'img',
            attributes: { src: iconEnergie }
        },
        child: [
            {
                title: 'Noe 3',
                href: window.CONFIG.external.noe3Url,
                icon: 'none'
            },
            {
                title: 'Noe EcoEnergie',
                href: window.CONFIG.external.noeEcoEnergieUrl,
                icon: 'none'
            },
            {
                icon: {
                    element: 'img',
                    attributes: { src: iconNew }
                },
                title: 'Connectez vos énergies',
                href: '/outils',
            }
        ]
    },
    {
        title: 'Réclamations',
        icon: {
            element: 'img',
            attributes: { src: iconReclamation }
        },
        child: [
            {
                title: 'Saisir une réclamation',
                href: '/reclamation',
                icon: 'none'
            },
            {
                title: 'Voir toutes les réclamations',
                href: '/suivi-reclamation',
                icon: 'none'
            },
        ]
    },
    {
        title: 'Satisfaction',
        icon: {
            element: 'img',
            attributes: { src: iconSatisfaction }
        },
        href: '/satisfaction'
    },
    {
        title: 'Contacts',
        href: '/contacts',
        icon: {
            element: 'img',
            attributes: { src: iconContact }
        },
    },
];


export const MENU_CLIENT_SWITCH_FOURNISSEUR = [
    {
        href: '/choix-portail-fournisseur',
        title: 'Portail fournisseur',
        icon: {
            element: 'img',
            attributes: { src: iconSwitchFournisseur },
        },
    },
    {
        href: '/dashboard',
        title: 'Dashboard',
        icon: {
            element: 'img',
            attributes: { src: iconMenu },
        },
    },
    {
        title: 'Interventions',
        icon: {
            element: 'img',
            attributes: { src: iconIntervention },
        },
        child: [
            {
                href: '/intervention',
                title: 'Faire une demande',
                icon: 'none',
            },
            {
                href: '/suivi-demande-intervention',
                title: 'Voir toutes les demandes',
                icon: 'none',
            },
            {
                href: '/suivi-preventif',
                title: 'Planning préventif',
                icon: 'none',
            },
            {
                href: '/suivi-interventions-preventives',
                title: 'Voir toutes les interventions préventives',
                icon: 'none',
            },
            {
                href: '/suivi-travaux',
                title: 'Voir toutes les interventions non préventives',
                icon: 'none',
            },
            {
                title: 'Rapports à signer',
                href: '/rapports-a-signer',
                icon: 'none',
            },
        ],
    },
    {
        title: 'Devis',
        icon: {
            element: 'img',
            attributes: { src: iconDevis },
        },
        child: [
            {
                href: '/devis',
                title: 'Faire une demande de devis',
                icon: 'none',
            },
            {
                title: 'Suivi des demandes de devis',
                href: '/suivi-demandes-devis',
                icon: 'none',
            },
            {
                href: '/suivi-devis',
                title: 'Voir tous les devis',
                icon: 'none',
            },
        ],
    },
    {
        title: 'Documents',
        icon: {
            element: 'img',
            attributes: { src: iconDocuments },
        },
        child: [
            {
                title: 'DOE',
                href: '/doe',
                icon: 'none',
            },
            {
                title: "Rapports d'intervention",
                href: '/rapports',
                icon: 'none',
            },
            {
                title: 'Réglementaires',
                href: '/documents',
                icon: 'none',
            },
        ],
    },
    {
        title: 'Administratif',
        icon: {
            element: 'img',
            attributes: { src: iconAdministratif },
        },
        child: [
            {
                title: 'Equipements',
                href: '/equipements',
                icon: 'none',
            },
            {
                title: 'Tags NFC',
                href: '/tag-nfc',
                icon: 'none',
            },
        ],
    },
    {
        title: 'Facturation',
        icon: {
            element: 'img',
            attributes: { src: iconFacturation },
        },
        href: '/facturation',
    },
    {
        title: 'Votre suivi énergétique',
        icon: {
            element: 'img',
            attributes: { src: iconEnergie },
        },
        child: [
            {
                title: 'Noe 3',
                href: window.CONFIG.external.noe3Url,
                icon: 'none',
            },
            {
                title: 'Noe EcoEnergie',
                href: window.CONFIG.external.noeEcoEnergieUrl,
                icon: 'none',
            },
            {
                icon: {
                    element: 'img',
                    attributes: { src: iconNew },
                },
                title: 'Connectez vos énergies',
                href: '/outils',
            },
        ],
    },
    {
        title: 'Réclamations',
        icon: {
            element: 'img',
            attributes: { src: iconReclamation },
        },
        child: [
            {
                title: 'Saisir une réclamation',
                href: '/reclamation',
                icon: 'none',
            },
            {
                title: 'Voir toutes les réclamations',
                href: '/suivi-reclamation',
                icon: 'none',
            },
        ],
    },
    {
        title: 'Satisfaction',
        icon: {
            element: 'img',
            attributes: { src: iconSatisfaction },
        },
        href: '/satisfaction',
    },
    {
        title: 'Contacts',
        href: '/contacts',
        icon: {
            element: 'img',
            attributes: { src: iconContact },
        },
    },
];

export const MENU_FOURNISSEUR = [
    {
        href: '/dashboard-fournisseur',
        title: 'Dashboard',
        icon: {
            element: 'img',
            attributes: { src: iconMenu}
        }
    },
    {
        title: 'Factures',
        href: '/factures-fournisseur',
        icon: {
            element: 'img',
            attributes: { src: iconFacturation}
        },
    },
    {
        title: 'Règlements',
        href: '/reglements-fournisseur',
        icon: {
            element: 'img',
            attributes: { src: iconDevis}
        },
    }
];

export const MENU_FOURNISSEUR_SWITCH_CLIENT = [
    {
        href: '/choix-portail-client',
        title: 'Portail client',
        icon: {
            element: 'img',
            attributes: { src: iconSwitchFournisseur}
        }
    },
    {
        href: '/dashboard-fournisseur',
        title: 'Dashboard',
        icon: {
            element: 'img',
            attributes: { src: iconMenu}
        }
    },
    {
        title: 'Factures',
        href: '/factures-fournisseur',
        icon: {
            element: 'img',
            attributes: { src: iconFacturation}
        },
    },
    {
        title: 'Règlements',
        href: '/reglements-fournisseur',
        icon: {
            element: 'img',
            attributes: { src: iconDevis}
        },
    },
];



export interface MenuState {
    menu: any[];
    choixMenu?: string;
    onBoardingOpen: boolean;
    listeSiteDisponibles : Site[];
    statutBim: StatutBim;
}

export const initialState: MenuState = {
    menu : MENU_CLIENT,
    onBoardingOpen: false,
    listeSiteDisponibles: [],
    statutBim: { bimVisible: false, bimConnected: false },
};

export const state: MenuState = {
    ...initialState,
};

export function updateMenuLabels() : void {
    MENU_CLIENT[0].title = i18n.global.t('menu.dashboard.client');
    MENU_CLIENT[1].title = i18n.global.t('menu.interventions.parent');
    if (MENU_CLIENT[1].child) {
        MENU_CLIENT[1].child[0].title = i18n.global.t('menu.interventions.demande');
        MENU_CLIENT[1].child[1].title = i18n.global.t('menu.interventions.suivi.demandes');
        MENU_CLIENT[1].child[2].title = i18n.global.t('menu.interventions.planning');
        MENU_CLIENT[1].child[3].title = i18n.global.t('menu.interventions.preventives');
        MENU_CLIENT[1].child[4].title = i18n.global.t('menu.interventions.non.preventives');
        MENU_CLIENT[1].child[5].title = i18n.global.t('menu.interventions.rapports');
    }

    MENU_CLIENT[2].title = i18n.global.t('menu.devis.parent');
    if (MENU_CLIENT[2].child) {
        MENU_CLIENT[2].child[0].title = i18n.global.t('menu.devis.demande');
        MENU_CLIENT[2].child[1].title = i18n.global.t('menu.devis.demandes');
        MENU_CLIENT[2].child[2].title = i18n.global.t('menu.devis.tous');
    }

    MENU_CLIENT[3].title = i18n.global.t('menu.documents.parent');
    if (MENU_CLIENT[3].child) {
        MENU_CLIENT[3].child[0].title = i18n.global.t('menu.documents.doe');
        MENU_CLIENT[3].child[1].title = i18n.global.t('menu.documents.rapports');
        MENU_CLIENT[3].child[2].title = i18n.global.t('menu.documents.reglementaires');
    }

    MENU_CLIENT[4].title = i18n.global.t('menu.administratif.parent');
    if (MENU_CLIENT[4].child) {
        MENU_CLIENT[4].child[0].title = i18n.global.t('menu.administratif.equipements');
        MENU_CLIENT[4].child[1].title = i18n.global.t('menu.administratif.tags');
    }

    MENU_CLIENT[5].title = i18n.global.t('menu.facturation');

    MENU_CLIENT[6].title = i18n.global.t('menu.energie.parent');
    if (MENU_CLIENT[6].child) {
        MENU_CLIENT[6].child[0].title = i18n.global.t('menu.energie.noe3');
        MENU_CLIENT[6].child[1].title = i18n.global.t('menu.energie.noeeco');
        MENU_CLIENT[6].child[2].title = i18n.global.t('menu.energie.connecter');
    }

    MENU_CLIENT[7].title = i18n.global.t('menu.reclamations.parent');
    if (MENU_CLIENT[7].child) {
        MENU_CLIENT[7].child[0].title = i18n.global.t('menu.reclamations.saisir');
        MENU_CLIENT[7].child[1].title = i18n.global.t('menu.reclamations.toutes');
    }

    MENU_CLIENT[8].title = i18n.global.t('menu.satisfaction');
    MENU_CLIENT[9].title = i18n.global.t('menu.contacts');

    MENU_CLIENT_SWITCH_FOURNISSEUR[0].title = i18n.global.t('menu.portail.fournisseur');
    MENU_CLIENT_SWITCH_FOURNISSEUR[1].title = i18n.global.t('menu.dashboard.client');
    MENU_CLIENT_SWITCH_FOURNISSEUR[2].title = i18n.global.t('menu.interventions.parent');
    if (MENU_CLIENT_SWITCH_FOURNISSEUR[2].child) {
        MENU_CLIENT_SWITCH_FOURNISSEUR[2].child[0].title = i18n.global.t('menu.interventions.demande');
        MENU_CLIENT_SWITCH_FOURNISSEUR[2].child[1].title = i18n.global.t('menu.interventions.suivi.demandes');
        MENU_CLIENT_SWITCH_FOURNISSEUR[2].child[2].title = i18n.global.t('menu.interventions.planning');
        MENU_CLIENT_SWITCH_FOURNISSEUR[2].child[3].title = i18n.global.t('menu.interventions.preventives');
        MENU_CLIENT_SWITCH_FOURNISSEUR[2].child[4].title = i18n.global.t('menu.interventions.non.preventives');
        MENU_CLIENT_SWITCH_FOURNISSEUR[2].child[5].title = i18n.global.t('menu.interventions.rapports');
    }

    MENU_CLIENT_SWITCH_FOURNISSEUR[3].title = i18n.global.t('menu.devis.parent');
    if (MENU_CLIENT_SWITCH_FOURNISSEUR[3].child) {
        MENU_CLIENT_SWITCH_FOURNISSEUR[3].child[0].title = i18n.global.t('menu.devis.demande');
        MENU_CLIENT_SWITCH_FOURNISSEUR[3].child[1].title = i18n.global.t('menu.devis.demandes');
        MENU_CLIENT_SWITCH_FOURNISSEUR[3].child[2].title = i18n.global.t('menu.devis.tous');
    }

    MENU_CLIENT_SWITCH_FOURNISSEUR[4].title = i18n.global.t('menu.documents.parent');
    if (MENU_CLIENT_SWITCH_FOURNISSEUR[4].child) {
        MENU_CLIENT_SWITCH_FOURNISSEUR[4].child[0].title = i18n.global.t('menu.documents.doe');
        MENU_CLIENT_SWITCH_FOURNISSEUR[4].child[1].title = i18n.global.t('menu.documents.rapports');
        MENU_CLIENT_SWITCH_FOURNISSEUR[4].child[2].title = i18n.global.t('menu.documents.reglementaires');
    }

    MENU_CLIENT_SWITCH_FOURNISSEUR[5].title = i18n.global.t('menu.administratif.parent');
    if (MENU_CLIENT_SWITCH_FOURNISSEUR[5].child) {
        MENU_CLIENT_SWITCH_FOURNISSEUR[5].child[0].title = i18n.global.t('menu.administratif.equipements');
        MENU_CLIENT_SWITCH_FOURNISSEUR[5].child[1].title = i18n.global.t('menu.administratif.tags');
    }

    MENU_CLIENT_SWITCH_FOURNISSEUR[6].title = i18n.global.t('menu.facturation');

    MENU_CLIENT_SWITCH_FOURNISSEUR[7].title = i18n.global.t('menu.energie.parent');
    if (MENU_CLIENT_SWITCH_FOURNISSEUR[7].child) {
        MENU_CLIENT_SWITCH_FOURNISSEUR[7].child[0].title = i18n.global.t('menu.energie.noe3');
        MENU_CLIENT_SWITCH_FOURNISSEUR[7].child[1].title = i18n.global.t('menu.energie.noeeco');
        MENU_CLIENT_SWITCH_FOURNISSEUR[7].child[2].title = i18n.global.t('menu.energie.connecter');
    }

    MENU_CLIENT_SWITCH_FOURNISSEUR[8].title = i18n.global.t('menu.reclamations.parent');
    if (MENU_CLIENT_SWITCH_FOURNISSEUR[8].child) {
        MENU_CLIENT_SWITCH_FOURNISSEUR[8].child[0].title = i18n.global.t('menu.reclamations.saisir');
        MENU_CLIENT_SWITCH_FOURNISSEUR[8].child[1].title = i18n.global.t('menu.reclamations.toutes');
    }

    MENU_CLIENT_SWITCH_FOURNISSEUR[9].title = i18n.global.t('menu.satisfaction');
    MENU_CLIENT_SWITCH_FOURNISSEUR[10].title = i18n.global.t('menu.contacts');

    MENU_FOURNISSEUR[0].title = i18n.global.t('menu.dashboard.fournisseur');
    MENU_FOURNISSEUR[1].title = i18n.global.t('menu.factures');
    MENU_FOURNISSEUR[2].title = i18n.global.t('menu.reglements');

    MENU_FOURNISSEUR_SWITCH_CLIENT[0].title = i18n.global.t('menu.portail.client');
    MENU_FOURNISSEUR_SWITCH_CLIENT[1].title = i18n.global.t('menu.dashboard.fournisseur');
    MENU_FOURNISSEUR_SWITCH_CLIENT[2].title = i18n.global.t('menu.factures');
    MENU_FOURNISSEUR_SWITCH_CLIENT[3].title = i18n.global.t('menu.reglements');

    if (localStorage.getItem('isClient') === 'true' && localStorage.getItem('isFournisseur') === 'false') {
        store.commit('menuState/SET_MENU', MENU_CLIENT);
    } else if (localStorage.getItem('isClient') === 'false' && localStorage.getItem('isFournisseur') === 'true') {
        store.commit('menuState/SET_MENU', MENU_FOURNISSEUR);
    } else {
        store.commit('menuState/SET_MENU', store.getters['authenticationState/getPortailName'] === 'Client'
            ? MENU_CLIENT_SWITCH_FOURNISSEUR
            : MENU_FOURNISSEUR_SWITCH_CLIENT
        );
    }
}
